import { HOMEWORK_PRACTICE_TITLE, LEGACY_HOMEWORK_PRACTICE_TITLE } from '../homeworkPracticeTemplate';

// Generated handouts are titled "<template title> - <report date>" (see the
// generatedreports insert in MedicalScribeTranscriptionData.js).
const HOME_PRACTICE_REPORT_TITLE = new RegExp(
  `^(${HOMEWORK_PRACTICE_TITLE}|${LEGACY_HOMEWORK_PRACTICE_TITLE})( - |$)`, 'i');

export const isHomePracticeReportTitle = title =>
  typeof title === 'string' && HOME_PRACTICE_REPORT_TITLE.test(title.trim());

const PRACTICE_HEADING = /^\s*practice\s*\d+\s*[:：]\s*/i;
const TIMING_HEADING = /^\s*when and how long\s*$/i;
const clean = text => (text || '').replace(/\s+/g, ' ').trim();

// The handout template writes one "Practice N: <title>" heading per assigned
// exercise, optionally followed by a "When and how long" sub-section.
export function extractPractices(html) {
  if (!html || typeof DOMParser === 'undefined') return [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const practices = [];
  let current = null;
  let readTiming = false;
  doc.body.querySelectorAll('h1, h2, h3, h4, p, li').forEach(node => {
    const text = clean(node.textContent);
    if (/^H[1-4]$/.test(node.tagName)) {
      readTiming = false;
      if (PRACTICE_HEADING.test(text)) {
        current = { title: clean(text.replace(PRACTICE_HEADING, '')), timing: '' };
        if (current.title) practices.push(current);
      } else if (current && TIMING_HEADING.test(text)) {
        readTiming = true;
      } else if (node.tagName !== 'H3' && node.tagName !== 'H4') {
        current = null;
      }
      return;
    }
    if (readTiming && current && text && !current.timing) current.timing = text;
  });
  return practices;
}

// Newest prescription first; an exercise prescribed again keeps only its latest entry.
export function buildHomePracticeHistory(reports) {
  const seen = new Set();
  return (reports || [])
    .filter(report => isHomePracticeReportTitle(report?.title))
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .flatMap(report => extractPractices(report.content).map(practice => ({
      ...practice, prescribedAt: report.created_at, reportId: report.id,
    })))
    .filter(practice => {
      const key = practice.title.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}
